import { render } from "./CompleteScreen.vue?vue&type=template&id=320d422c&scoped=true"
const script = {}

import "./CompleteScreen.vue?vue&type=style&index=0&id=320d422c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320d422c"]])

export default __exports__